import React from "react";
import style from "../pagination/Pagination.module.css";

const Pagination = ({
  currentPage,
  totalPages,
  rowsPerPage,
  setCurrentPage,
  setRowsPerPage,
  totalCount,
  dataLength = 0,
  columnCount = 1,
  Styles = {},
  columnsLength,
  className="",
}) => {
  const getVisiblePages = () => {
    const pairStart = Math.floor((currentPage - 1) / 2) * 2 + 1;
    const pages = [];
    for (let i = pairStart; i < pairStart + 2 && i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };
  const combinedClassName = `${style.pagination} ${className}`.trim();
  return (
    <tfoot>
      {totalPages > 0 && (
        <tr>
          <td colSpan={columnsLength} >
          <div className={combinedClassName} style={Styles}>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={style.paginationButton}
            >
              Previous
            </button>

            {getVisiblePages().map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`${style.paginationButton} ${
                  currentPage === page ? style.activePage : ""
                }`}
              >
                {page}
              </button>
            ))}

            {totalPages > 2 && <span className={style.ellipsis}>...</span>}

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={style.paginationButton}
            >
              Next
            </button>
          </div>
          </td>
        </tr>
      )}
    </tfoot>
  );
};

export default Pagination;
